import APIKit from '../Allapis/Apikit/apikit'

export const getRequest = async slug => {
  const endpoint = `/requests/${slug}`
  const res = await APIKit.get(endpoint)
  return res.data
}
